// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ql-0";